import { fetchFile, fetchFilePut, fetchJSON } from "./fetchJSON";
import { baseUrl } from "./baseUrl";
import { FrequenceForm } from "pages/ParametrageSociete/Frequences";
import { CanauxForm } from "pages/ParametrageSociete/Canaux";
import { AlertesForm } from "pages/ParametrageSociete/Aletes";

// INFORMATIONS

export type Information = {
  nomSociete: string;
  code: string;
  type: string;
  codeBcf: string;
  email: string;
  emailNotificationTechnique: string;
  emailNotificationFonctionnelle: string;
  idSociete: number;
  actif: boolean;
  referentielSinistreAlt: boolean;
  sessionInterrogationGlobale: boolean;
  adresse1?: string;
  adresse2?: string;
  adresse3?: string;
  codePostal?: string;
  ville?: string;
  pays?: string;
  logo?: File | undefined;
  logoMetaData?: string;
};

export type ParametresSociete = {
  informations: Information;
  logo: ArrayBuffer | null;
};

export async function getSocieteInformations(idSociete: number) {
  return fetchJSON<ParametresSociete>(
    new URL(`/backend/v1/societe/${idSociete}/informations`, baseUrl),
  );
}

export async function updateSocieteInformations(formData: FormData, idSociete: number) {
  type UpdateInformationReturn = {
    headers: {};
    body: {
      succes: true;
    };
    statusCode: "OK";
    statusCodeValue: 200;
  };
  return fetchFilePut<UpdateInformationReturn>(
    new URL(`/backend/v1/societe/${idSociete}/informations`, baseUrl),
    {
      body: formData,
    },
  );
}

type CreateInformationReturn = Information & { idSociete: number };

export function createSocieteInformations(formData: FormData) {
  return fetchFile<CreateInformationReturn>(new URL(`/backend/v1/societe`, baseUrl), {
    body: formData,
  });
}

export function deactivateSociete(idSociete: number) {
  return fetchJSON<{
    headers: {};
    body: {
      succes: true;
    };
    statusCode: "OK";
    statusCodeValue: 200;
  }>(new URL(`/backend/v1/societe/${idSociete}/deactivate`, baseUrl), {
    method: "PUT",
  });
}

export function reactivateSociete(idSociete: number) {
  return fetchJSON<{
    headers: {};
    body: {
      succes: true;
    };
    statusCode: "OK";
    statusCodeValue: 200;
  }>(new URL(`/backend/v1/societe/${idSociete}/reactivate`, baseUrl), {
    method: "PUT",
  });
}

// CANAUX

export type Canal = {
  canaux: string;
  autorises: boolean;
};

export async function getSocieteCanaux(idSociete: number): Promise<Canal[]> {
  return fetchJSON<Canal[]>(new URL(`/backend/v1/societe/${idSociete}/canaux`, baseUrl));
}

export async function updateSocieteCanaux(idSociete: number, data: CanauxForm) {
  return fetchJSON(new URL(`/backend/v1/societe/${idSociete}/canaux`, baseUrl), {
    method: "PUT",
    data,
  });
}

// Frequences
type Frequence = {
  typeFrequence: string;
  periodicite: string;
  jour?: number;
};

export async function getSocieteFrequences(idSociete: number) {
  return fetchJSON<Frequence[]>(new URL(`/backend/v1/societe/${idSociete}/frequences`, baseUrl));
}

export function updateSocieteFrequences(idSociete: number, data: FrequenceForm[]) {
  return fetchJSON(new URL(`/backend/v1/societe/${idSociete}/frequences`, baseUrl), {
    method: "PUT",
    data,
  });
}

// Alertes
type Alerte = {
  typeAlerte: string;
  libelle: string;
  fichiersXml: boolean;
  ihm: boolean;
};

export async function getSocieteAlertes(idSociete: number): Promise<Alerte[]> {
  return fetchJSON<Alerte[]>(new URL(`/backend/v1/societe/${idSociete}/alertes`, baseUrl));
}

export function updateSocieteAlertes(idSociete: number, data: AlertesForm) {
  return fetchJSON(new URL(`/backend/v1/societe/${idSociete}/alertes`, baseUrl), {
    method: "PUT",
    data,
  });
}
